<template>
  <div
    v-if="!lazy || loaded || active"
    v-show="active"
    :id="`pane-${paneName}`"
    class="el-tab-pane"
    role="tabpanel"
    :aria-hidden="!active"
    :aria-labelledby="`tab-${paneName}`"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'ElTabPane',

  componentName: 'ElTabPane',

  props: {
    label: {
      type: String,
      default: '',
    },
    labelContent: {
      type: Function,
      default: () => {},
    },
    name: {
      type: String,
      default: '',
    },
    closable: Boolean,
    disabled: Boolean,
    lazy: Boolean,
  },

  data() {
    return {
      index: null,
      loaded: false,
    };
  },

  computed: {
    isClosable() {
      return this.closable || this.$parent.closable;
    },
    active() {
      const active = this.$parent.currentName === (this.name || this.index);
      return active;
    },
    paneName() {
      return this.name || this.index;
    },
  },

  watch: {
    active(val) {
      if (val) {
        this.loaded = true;
      } else {
        this.loaded = false;
      }
    },
    label() {
      this.$parent.$forceUpdate();
    },
  },
};
</script>
